import { PaginacionProps } from "../global/PaginacionInterface";
import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";
import { defaultIrregular, IrregularProps } from "../recepcion/IrregularInterface";

export const defaultBuscarLibroAuxiliarResponse: BuscarLibroAuxiliarResponse = { currentPageIndex: 0, pageCount: 0, recordCount: 0, records: [] };

export const defaultBuscarLibroAuxiliar: BuscarLibroAuxiliar = { idAutoridad: 0, numeroReferencia: '' };

export const defaultLibroAuxiliar: LibroAuxiliarProps = {
    idLibroAuxiliar:        0,
    idIrregular:            0,
    idExpediente:           0,
    numeroExpediente:       '',
    numeroIrregular:        '',
    tipoIrregular:          '',
    actor:                  '',
    demandado:              '',
    observaciones:          '',
    acuerdo:                '',
    expediente:             defaultExpediente,
    irregular:              defaultIrregular,
};

// Creación de interfaces

export interface LibroAuxiliarProps {
    idLibroAuxiliar:            number;
    idIrregular:                number;
    idExpediente:               number;
    numeroExpediente:           string;
    numeroIrregular:            string;
    tipoIrregular:              string;
    fechaAcuerdo?:              Date;
    actor:                      string;
    demandado:                  string;
    observaciones:              string;
    acuerdo:                    string;
    expediente:                 ExpedienteProps;
    irregular:                  IrregularProps;
}

export interface BuscarLibroAuxiliar {
    idAutoridad:                number;
    numeroReferencia:           string;
}

export interface BuscarLibroAuxiliarParams extends PaginacionProps, BuscarLibroAuxiliar {}

export interface BuscarLibroAuxiliarResponse {
    currentPageIndex:           number;
    pageCount:                  number;
    recordCount:                number;
    records:                    LibroAuxiliarProps[];
}

export interface GuardarObservaciones {
    id:                         number;
    observaciones:              string;
}

export interface DescargarInformacionParams {
    idAutoridad:                number;
    numeroReferencia:           string;
}